import { operate } from '../util/lift';
export function subscribeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return operate(function (source, subscriber) {
    subscriber.add(scheduler.schedule(function () {
      return source.subscribe(subscriber);
    }, delay));
  });
}